const networkOnly = {
  options: {
    fetchPolicy: 'network-only',
  },
}

export default networkOnly



// WEBPACK FOOTER //
// ./src/apollo/options/networkOnly.js